import { defineNuxtPlugin } from '#app/nuxt'
import { LazyJobFiltersOverlay, LazyMopBlogNewsItem, LazyMopBreadcrumb, LazyMopCookiesOverlay, LazyMopNavigationTree, LazyMopNotFound, LazyMopPageLoad, LazyMopSearchForm, LazyMopCmsContentElementsSlot, LazyMopCmsCompanyAudio, LazyMopCmsCompanyBlogNewsTripleCard, LazyMopCmsCompanyTopJobs, LazyMopCmsCompanyVacancies, LazyMopFooter, LazyMopFooterJobsStickyButton, LazyMopHeader, LazyMopHeaderMenuOverlay, LazyMopHeaderMobileMenuOverlay, LazyMopHeaderMobileMenuSlider, LazyMopHeaderSearchSuggestionsOverlay, LazyMopJobFilter, LazyMopJobFilters, LazyMopOverlayManager, LazyMopOverlay, LazyUiCmsAnchor, LazyUiCmsBenefit, LazyUiCmsCardCarousel, LazyUiCmsCardItem, LazyUiCmsCountdown, LazyUiCmsCta, LazyUiCmsDoubleCard, LazyUiCmsElementNotFound, LazyUiCmsFaqImageTiles, LazyUiCmsFaqTextTiles, LazyUiCmsFullWidthBanner, LazyUiCmsGenderSwitch, LazyUiCmsGenderSwitchItem, LazyUiCmsHeadline, LazyUiCmsHtml, LazyUiCmsImageText, LazyUiCmsImprintText, LazyUiCmsMedia, LazyUiCmsRichText, LazyUiCmsSeoTeaser, LazyUiCmsSeparator, LazyUiCmsSlider, LazyUiCmsSliderSlide, LazyUiCmsStaticNavigation, LazyUiCmsTable, LazyUiCmsTextCarousel, LazyUiCmsTimeline, LazyUiCmsTimelineItem, LazyUiCmsTripleCard, LazyUiCmsTripleTeaser, LazyUiCmsTripleTeaserItemBig, LazyUiCmsTripleTeaserItemSmall, LazyUiCmsVideoVimeo, LazyUiAccordion, LazyUiCarousel, LazyUiColorSwatch, LazyUiForm, LazyUiFormCheckbox, LazyUiFormFile, LazyUiFormGroup, LazyUiFormInput, LazyUiFormPasswordInput, LazyUiFormRadio, LazyUiFormSelect, LazyUiFormTextArea, LazyUiGoogleMap, LazyUiGrid, LazyUiGridItem, LazyUiHeading, LazyUiImage, LazyUiImageCarousel, LazyUiNotification, LazyUiNuxtLink, LazyUiPagination, LazyUiScrollNavigation, LazyUiSlot, LazyUiSpinner, LazyUiTooltip, LazyUiVideoVimeo, LazyUi2Accordion, LazyUi2Avatar, LazyUi2Badge, LazyUi2Breadcrumbs, LazyUi2Button, LazyUi2Carousel, LazyUi2CarouselArrow, LazyUi2CarouselScrollBar, LazyUi2CarouselSlide, LazyUi2CheckBox, LazyUi2CheckoutHeader, LazyUi2Collapse, LazyUi2CompanyAudio, LazyUi2Datepicker, LazyUi2DotBadge, LazyUi2DropdownMenu, LazyUi2DropdownSelect, LazyUi2DropdownSelectItem, LazyUi2Dummy, LazyUi2EcomCallout, LazyUi2EcomPopularityFlag, LazyUi2EcomPrice, LazyUi2EcomProductCard, LazyUi2FileUpload, LazyUi2FormDivider, LazyUi2Form, LazyUi2Icon, LazyUi2Image, LazyUi2Loader, LazyUi2Notification, LazyUi2NuxtLink, LazyUi2Overlay, LazyUi2OverlayHeader, LazyUi2Pagination, LazyUi2PaginationDots, LazyUi2Progress, LazyUi2Radio, LazyUi2RadioCard, LazyUi2RadioCardGroup, LazyUi2RangeSlider, LazyUi2Tab, LazyUi2TabGroup, LazyUi2TabImage, LazyUi2TabPanel, LazyUi2Tag, LazyUi2TextFieldArea, LazyUi2TextFieldBirthday, LazyUi2TextFieldInput, LazyUi2TextFieldPassword, LazyUi2Toast, LazyUi2Toggle, LazyUi2Tooltip } from '#components'
const lazyGlobalComponents = [
  ["JobFiltersOverlay", LazyJobFiltersOverlay],
["MopBlogNewsItem", LazyMopBlogNewsItem],
["MopBreadcrumb", LazyMopBreadcrumb],
["MopCookiesOverlay", LazyMopCookiesOverlay],
["MopNavigationTree", LazyMopNavigationTree],
["MopNotFound", LazyMopNotFound],
["MopPageLoad", LazyMopPageLoad],
["MopSearchForm", LazyMopSearchForm],
["MopCmsContentElementsSlot", LazyMopCmsContentElementsSlot],
["MopCmsCompanyAudio", LazyMopCmsCompanyAudio],
["MopCmsCompanyBlogNewsTripleCard", LazyMopCmsCompanyBlogNewsTripleCard],
["MopCmsCompanyTopJobs", LazyMopCmsCompanyTopJobs],
["MopCmsCompanyVacancies", LazyMopCmsCompanyVacancies],
["MopFooter", LazyMopFooter],
["MopFooterJobsStickyButton", LazyMopFooterJobsStickyButton],
["MopHeader", LazyMopHeader],
["MopHeaderMenuOverlay", LazyMopHeaderMenuOverlay],
["MopHeaderMobileMenuOverlay", LazyMopHeaderMobileMenuOverlay],
["MopHeaderMobileMenuSlider", LazyMopHeaderMobileMenuSlider],
["MopHeaderSearchSuggestionsOverlay", LazyMopHeaderSearchSuggestionsOverlay],
["MopJobFilter", LazyMopJobFilter],
["MopJobFilters", LazyMopJobFilters],
["MopOverlayManager", LazyMopOverlayManager],
["MopOverlay", LazyMopOverlay],
["UiCmsAnchor", LazyUiCmsAnchor],
["UiCmsBenefit", LazyUiCmsBenefit],
["UiCmsCardCarousel", LazyUiCmsCardCarousel],
["UiCmsCardItem", LazyUiCmsCardItem],
["UiCmsCountdown", LazyUiCmsCountdown],
["UiCmsCta", LazyUiCmsCta],
["UiCmsDoubleCard", LazyUiCmsDoubleCard],
["UiCmsElementNotFound", LazyUiCmsElementNotFound],
["UiCmsFaqImageTiles", LazyUiCmsFaqImageTiles],
["UiCmsFaqTextTiles", LazyUiCmsFaqTextTiles],
["UiCmsFullWidthBanner", LazyUiCmsFullWidthBanner],
["UiCmsGenderSwitch", LazyUiCmsGenderSwitch],
["UiCmsGenderSwitchItem", LazyUiCmsGenderSwitchItem],
["UiCmsHeadline", LazyUiCmsHeadline],
["UiCmsHtml", LazyUiCmsHtml],
["UiCmsImageText", LazyUiCmsImageText],
["UiCmsImprintText", LazyUiCmsImprintText],
["UiCmsMedia", LazyUiCmsMedia],
["UiCmsRichText", LazyUiCmsRichText],
["UiCmsSeoTeaser", LazyUiCmsSeoTeaser],
["UiCmsSeparator", LazyUiCmsSeparator],
["UiCmsSlider", LazyUiCmsSlider],
["UiCmsSliderSlide", LazyUiCmsSliderSlide],
["UiCmsStaticNavigation", LazyUiCmsStaticNavigation],
["UiCmsTable", LazyUiCmsTable],
["UiCmsTextCarousel", LazyUiCmsTextCarousel],
["UiCmsTimeline", LazyUiCmsTimeline],
["UiCmsTimelineItem", LazyUiCmsTimelineItem],
["UiCmsTripleCard", LazyUiCmsTripleCard],
["UiCmsTripleTeaser", LazyUiCmsTripleTeaser],
["UiCmsTripleTeaserItemBig", LazyUiCmsTripleTeaserItemBig],
["UiCmsTripleTeaserItemSmall", LazyUiCmsTripleTeaserItemSmall],
["UiCmsVideoVimeo", LazyUiCmsVideoVimeo],
["UiAccordion", LazyUiAccordion],
["UiCarousel", LazyUiCarousel],
["UiColorSwatch", LazyUiColorSwatch],
["UiForm", LazyUiForm],
["UiFormCheckbox", LazyUiFormCheckbox],
["UiFormFile", LazyUiFormFile],
["UiFormGroup", LazyUiFormGroup],
["UiFormInput", LazyUiFormInput],
["UiFormPasswordInput", LazyUiFormPasswordInput],
["UiFormRadio", LazyUiFormRadio],
["UiFormSelect", LazyUiFormSelect],
["UiFormTextArea", LazyUiFormTextArea],
["UiGoogleMap", LazyUiGoogleMap],
["UiGrid", LazyUiGrid],
["UiGridItem", LazyUiGridItem],
["UiHeading", LazyUiHeading],
["UiImage", LazyUiImage],
["UiImageCarousel", LazyUiImageCarousel],
["UiNotification", LazyUiNotification],
["UiNuxtLink", LazyUiNuxtLink],
["UiPagination", LazyUiPagination],
["UiScrollNavigation", LazyUiScrollNavigation],
["UiSlot", LazyUiSlot],
["UiSpinner", LazyUiSpinner],
["UiTooltip", LazyUiTooltip],
["UiVideoVimeo", LazyUiVideoVimeo],
["Ui2Accordion", LazyUi2Accordion],
["Ui2Avatar", LazyUi2Avatar],
["Ui2Badge", LazyUi2Badge],
["Ui2Breadcrumbs", LazyUi2Breadcrumbs],
["Ui2Button", LazyUi2Button],
["Ui2Carousel", LazyUi2Carousel],
["Ui2CarouselArrow", LazyUi2CarouselArrow],
["Ui2CarouselScrollBar", LazyUi2CarouselScrollBar],
["Ui2CarouselSlide", LazyUi2CarouselSlide],
["Ui2CheckBox", LazyUi2CheckBox],
["Ui2CheckoutHeader", LazyUi2CheckoutHeader],
["Ui2Collapse", LazyUi2Collapse],
["Ui2CompanyAudio", LazyUi2CompanyAudio],
["Ui2Datepicker", LazyUi2Datepicker],
["Ui2DotBadge", LazyUi2DotBadge],
["Ui2DropdownMenu", LazyUi2DropdownMenu],
["Ui2DropdownSelect", LazyUi2DropdownSelect],
["Ui2DropdownSelectItem", LazyUi2DropdownSelectItem],
["Ui2Dummy", LazyUi2Dummy],
["Ui2EcomCallout", LazyUi2EcomCallout],
["Ui2EcomPopularityFlag", LazyUi2EcomPopularityFlag],
["Ui2EcomPrice", LazyUi2EcomPrice],
["Ui2EcomProductCard", LazyUi2EcomProductCard],
["Ui2FileUpload", LazyUi2FileUpload],
["Ui2FormDivider", LazyUi2FormDivider],
["Ui2Form", LazyUi2Form],
["Ui2Icon", LazyUi2Icon],
["Ui2Image", LazyUi2Image],
["Ui2Loader", LazyUi2Loader],
["Ui2Notification", LazyUi2Notification],
["Ui2NuxtLink", LazyUi2NuxtLink],
["Ui2Overlay", LazyUi2Overlay],
["Ui2OverlayHeader", LazyUi2OverlayHeader],
["Ui2Pagination", LazyUi2Pagination],
["Ui2PaginationDots", LazyUi2PaginationDots],
["Ui2Progress", LazyUi2Progress],
["Ui2Radio", LazyUi2Radio],
["Ui2RadioCard", LazyUi2RadioCard],
["Ui2RadioCardGroup", LazyUi2RadioCardGroup],
["Ui2RangeSlider", LazyUi2RangeSlider],
["Ui2Tab", LazyUi2Tab],
["Ui2TabGroup", LazyUi2TabGroup],
["Ui2TabImage", LazyUi2TabImage],
["Ui2TabPanel", LazyUi2TabPanel],
["Ui2Tag", LazyUi2Tag],
["Ui2TextFieldArea", LazyUi2TextFieldArea],
["Ui2TextFieldBirthday", LazyUi2TextFieldBirthday],
["Ui2TextFieldInput", LazyUi2TextFieldInput],
["Ui2TextFieldPassword", LazyUi2TextFieldPassword],
["Ui2Toast", LazyUi2Toast],
["Ui2Toggle", LazyUi2Toggle],
["Ui2Tooltip", LazyUi2Tooltip],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
